export const APPLINKS = {
    dashboard: '/dashboard',
    docs: '/docs',
    login: '/login',
    signup: '/signup',
    settings: '/settings',
    invoice: '/invoice',
    invoiceShow: '/invoice/:id',
    editBill: '/editbill/:id',
    edit: '/editbill',
    createInvoice: '/createInvoice',
    purchaseEntry: '/purchase',
    purchaseList: '/purchaseList',
    ledger: '/ledger',
    ledgerList: '/ledger/:id',
    customerDetails: '/ledger/:name',
    company: '/company',
    expenses: '/expenses',
    stocks: '/stocks',
    stockItem: '/stocks/:id',
    reports: '/reports',
    dev: '/dev/_tools',
}